import { useCallback, useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import { matchPath } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { useSelector, useDispatch } from 'react-redux';
import { api, Names } from 'Utils';
import { useDelayUnmount } from 'Hooks';
import {
	setFilterMarkers,
	getMarkersRequest,
	getMarkersFail,
	setSelectedMarker,
	setSidebar,
	setOriginMarkers,
	setFilterData
} from 'Actions';
import {
	PageFrame,
	Mapbox,
	PageSidebar,
	MobileTopBar,
	Overlay,
	NotifWrapper
} from 'Elements';

export const Home = () => {
	const [list, setList] = useState([]);
	const { data, error } = useSWR(api.getMarkers);
	const dispatch = useDispatch();
	const sidebar = useSelector((state) => state.sidebar);
	const isMounted = useRef(null);
	const isMobile = useMediaQuery({ maxWidth: 992 });
	const isTablet = useMediaQuery({ minWidth: 575, maxWidth: 992 });
	const isOpenSide = sidebar.isOpen;
	const match = matchPath(location.pathname, {
		path: `${Names.story.path}/:story_id/:story_slug`,
		exact: true,
		strict: false
	});
	const params = match?.params;
	const selectedId = params?.story_id;
	// const shouldRenderSidebar = useDelayUnmount(isOpenSide || !isMobile, 350);
	// console.log('shouldRenderSidebar: ', shouldRenderSidebar);
	const shouldRenderOverlay = useDelayUnmount(isOpenSide, 350);

	const getMarkers = useCallback(() => {
		dispatch(getMarkersRequest());
		if (data) {
			dispatch(setFilterMarkers(data.list));
			dispatch(setOriginMarkers(data.list));
			dispatch(setFilterData(data.list));
		}
		if (error) {
			dispatch(getMarkersFail());
		}
	}, [dispatch, data, error]);

	const closeSidebar = () => {
		dispatch(setSidebar(false));
		dispatch(setSelectedMarker({}));
	};

	useEffect(() => {
		getMarkers();
		isMobile && selectedId && dispatch(setSidebar(true));
	}, [getMarkers, selectedId, dispatch, isMobile]);

	useEffect(() => {
		if (data && isMounted.current) {
			setList(data.list);
		}
		isMounted.current = true;
	}, [data]);

	return (
		<PageFrame>
			{isMobile && <MobileTopBar isOpenSide={isOpenSide} />}
			<PageSidebar isOpen={isMobile && isOpenSide} />
			{shouldRenderOverlay && isTablet && (
				<Overlay isOpen={isOpenSide} onClick={closeSidebar} />
			)}
			<NotifWrapper list={list} />
			<Mapbox />
		</PageFrame>
	);
};
